import api from '../api/apiClient';

export const profileService = {
  async getProfile() {
    // Via Auth Microservice
    const response = await api.get('/auth/api/profile-details');
    return response.data;
  },
};
